import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ButtonWithIcon extends Component {

  render() {
    const {label, icon, style, disabled} = this.props;

    return (
      <div className={'button-with-icon ' + (disabled ? 'disabled' : '')} style={style} onClick={disabled ? null : this.props.onClick}>
        <i className={icon + ' icon'} />
        <label>{label}</label>
      </div>
    );
  }
}

ButtonWithIcon.propTypes = {
    label: PropTypes.string,
  icon: PropTypes.any,
  style: PropTypes.any,
  disabled: PropTypes.any,
  onClick: PropTypes.any,
};

export default ButtonWithIcon;
